import { useEffect, useState } from 'react';
import api from '../utils/api';

// Tiny inline strip of a user's pinned sticker emojis (max 6).
// Cached process-wide so re-rendering chat headers doesn't re-fetch.
const cache = new Map(); // userId → { showcase, fetchedAt }
const TTL_MS = 60_000;

export default function StickerShowcaseInline({ userId, size = 14 }) {
  const [showcase, setShowcase] = useState(() => {
    const c = cache.get(userId);
    return c && Date.now() - c.fetchedAt < TTL_MS ? c.showcase : null;
  });

  useEffect(() => {
    if (!userId) return;
    const cached = cache.get(userId);
    if (cached && Date.now() - cached.fetchedAt < TTL_MS) {
      setShowcase(cached.showcase);
      return;
    }
    let cancelled = false;
    api.get(`/stickers/users/${userId}`).then((res) => {
      if (cancelled) return;
      const data = res.data?.showcase || [];
      cache.set(userId, { showcase: data, fetchedAt: Date.now() });
      setShowcase(data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [userId]);

  if (!showcase || showcase.length === 0) return null;

  return (
    <span
      title={showcase.map(s => `${s.emoji || ''} ${s.name}`).join(' · ')}
      style={{
        display: 'inline-flex',
        gap: 2,
        fontSize: size,
        lineHeight: 1,
        marginLeft: 6,
        verticalAlign: 'middle',
      }}
    >
      {showcase.map((s, i) => <span key={i}>{s.emoji || '🎖️'}</span>)}
    </span>
  );
}
